const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, Record<string, Record<string, string>>> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, namespace] = match;
    const module = modules[path] as Record<string, Record<string, string>>;

    if (!messages[lang]) {
      messages[lang] = {};
    }
    if (!messages[lang][namespace]) {
      messages[lang][namespace] = {};
    }

    // 优先读取命名导出（如 module.en），回退到 default export
    const translations = module[lang] || module.default;
    if (translations) {
      messages[lang][namespace] = {
        ...messages[lang][namespace],
        ...translations,
      };
    }
  }
});

export default messages;